export default "__VITE_ASSET__BXAReRJ___"